"use strict";
var _a, _b;
Object.defineProperty(exports, "__esModule", { value: true });
exports.getGameMetaData = exports.gameMetaData = void 0;
var types_1 = require("./types");
var magicRarities = {
    1: { name: 'Other', filterLabel: 'Oth' },
    2: { name: 'Basic Land', filterLabel: 'Lnd', separateFoilBulkPrice: true },
    3: { name: 'Token', filterLabel: 'Tkn', separateFoilBulkPrice: true },
    4: { name: 'Common', filterLabel: 'C', separateFoilBulkPrice: true },
    5: { name: 'Uncommon', filterLabel: 'U', separateFoilBulkPrice: true },
    6: { name: 'Rare', filterLabel: 'R', separateFoilBulkPrice: true },
    7: { name: 'Mythic', filterLabel: 'M', separateFoilBulkPrice: true },
    8: { name: 'Masterpiece', filterLabel: 'Msp' },
    9: { name: 'Special', filterLabel: 'Sp' },
};
var magicRarityMap = {
    'Arena Code Card': 1,
    'Code Card': 1,
    'Tip Card': 1,
    Land: 2,
    Token: 3,
    Common: 4,
    Uncommon: 5,
    Rare: 6,
    'Time Shifted': 6,
    Mythic: 7,
    Masterpiece: 8,
    Special: 9,
};
var yugiohRarities = {
    1: { name: 'Token', filterLabel: 'Tkn' },
    2: { name: 'Common', filterLabel: 'C' },
    3: { name: 'Rare', filterLabel: 'R' },
    4: { name: 'Special', filterLabel: 'Sp' },
    5: { name: 'Super Rare', filterLabel: 'SuR' },
    6: { name: 'Ultra Rare', filterLabel: 'UR' },
    7: { name: 'Secret Rare', filterLabel: 'ScR' },
    8: { name: 'Ultimate Rare', filterLabel: 'ULT' },
    9: { name: 'Ghost Rare', filterLabel: 'GR' },
    10: { name: 'Starfoil Rare', filterLabel: 'StfR' },
    11: { name: 'Mosaic Rare', filterLabel: 'MR' },
    12: { name: 'Shatterfoil', filterLabel: 'Shf' },
    13: { name: 'Platinum Rare', filterLabel: 'PR' },
    14: { name: 'Gold Rare', filterLabel: 'GR' },
    15: { name: 'Gold Secret Rare', filterLabel: 'GSR' },
    16: { name: 'Premium Gold Rare', filterLabel: 'PGR' },
    17: { name: 'Collectors Rare', filterLabel: 'CR' },
    18: { name: 'Starlight Rare', filterLabel: 'StlR' },
    19: { name: 'Oversized', filterLabel: 'Ovs' },
    20: { name: 'Platinum Secret Rare', filterLabel: 'PlSR' },
};
var yugiohRarityMap = {
    Token: 1,
    Common: 2,
    Unknown: 2,
    Rare: 3,
    Special: 4,
    'Super Rare': 5,
    'Ultra Rare': 6,
    'Secret Rare': 7,
    'Extra Secret Rare': 7,
    'Ultimate Rare': 8,
    'Ghost Rare': 9,
    'Starfoil Rare': 10,
    'Parallel Rare': 10,
    'Secret Parallel Rare': 10,
    'Super Parallel Rare': 10,
    'Ultra Parallel Rare': 10,
    'Mosaic Rare': 11,
    Shatterfoil: 12,
    'Platinum Rare': 13,
    'Gold Rare': 14,
    'Gold Secret Rare': 15,
    'Premium Gold Rare': 16,
    'Collectors Rare': 17,
    'Starlight Rare': 18,
    'Quarter Century Secret Rare': 18,
    'Holographic Rare': 18,
    Oversized: 19,
    'Platinum Secret Rare': 20,
};
var pokemonRarities = {
    1: { name: 'Other', filterLabel: 'Oth' },
    2: { name: 'Common', filterLabel: 'C' },
    3: { name: 'Uncommon', filterLabel: 'U' },
    4: { name: 'Rare', filterLabel: 'R' },
    5: { name: 'Holo Rare', filterLabel: 'HR' },
    6: { name: 'Double Rare', filterLabel: 'DR' },
    7: { name: 'Triple Rare', filterLabel: 'TR' },
    8: { name: 'Amazing Rare', filterLabel: 'AR' },
    9: { name: 'Ultra Rare', filterLabel: 'UR' },
    10: { name: 'Secret Rare', filterLabel: 'SR' },
    11: { name: 'Promo', filterLabel: 'Prm' },
    12: { name: 'Oversized', filterLabel: 'Ovs' },
    13: { name: 'Shiny Rare', filterLabel: 'ShR' },
};
var pokemonRarityMap = {
    'Online Code Card': 1,
    Common: 2,
    Uncommon: 3,
    Rare: 4,
    'Character Rare': 4,
    'Character Super Rare': 4,
    'Holo Rare': 5,
    Kagayaku: 5,
    'Illustration Rare': 6,
    'ACE Rare': 6,
    'Double Rare': 6,
    'Triple Rare': 7,
    'Amazing Rare': 8,
    'Ultra Rare': 9,
    'Special Illustration Rare': 9,
    'Secret Rare': 10,
    Promo: 11,
    Fixed: 11,
    Oversized: 12,
    'Shiny Rare': 13,
    'Shiny Ultra Rare': 13,
};
var fabRarities = {
    1: { name: 'Token', filterLabel: 'Tkn' },
    2: { name: 'Promo', filterLabel: 'Prm' },
    3: { name: 'Common', filterLabel: 'C' },
    4: { name: 'Rare', filterLabel: 'R' },
    5: { name: 'Super Rare', filterLabel: 'SR' },
    6: { name: 'Majestic', filterLabel: 'M' },
    7: { name: 'Legendary', filterLabel: 'L' },
    8: { name: 'Fabled', filterLabel: 'F' },
};
var fabRarityMap = {
    Token: 1,
    Promo: 2,
    Common: 3,
    Rare: 4,
    'Super Rare': 5,
    Majestic: 6,
    Marvel: 7,
    Legendary: 7,
    Fabled: 8,
};
var VanguardSpecial;
(function (VanguardSpecial) {
    VanguardSpecial[VanguardSpecial["rarity"] = 10] = "rarity";
})(VanguardSpecial || (VanguardSpecial = {}));
var vanguardRarities = (_a = {
        1: { name: 'Token', filterLabel: 'Tok' },
        2: { name: 'Common', filterLabel: 'C' },
        3: { name: 'Rare', filterLabel: 'R' },
        4: { name: 'Holo', filterLabel: 'Ho' },
        5: { name: 'Double Rare', filterLabel: 'DR' },
        6: { name: 'Over Double Rare', filterLabel: 'ODR' },
        7: { name: 'Triple Rare', filterLabel: 'TR' },
        8: { name: 'Vanguard Rare', filterLabel: 'VaR' },
        9: { name: 'Generation Rare', filterLabel: 'GeR' }
    },
    _a[VanguardSpecial.rarity] = { name: 'Special', filterLabel: 'Spe' },
    _a[11] = { name: 'Trial Deck', filterLabel: 'TrD' },
    _a[12] = { name: 'Frame Rare', filterLabel: 'FR' },
    _a[13] = { name: 'Double Frame Rare', filterLabel: 'DFR' },
    _a);
var vanguardRarityMap = {
    Token: 1,
    Promo: VanguardSpecial.rarity,
    Common: 2,
    'Holo Rare Common': VanguardSpecial.rarity,
    Rare: 3,
    Holo: 4,
    'Double Rare': 5,
    'Over RR': 6,
    'Triple Rare': 7,
    'Feature Rare': VanguardSpecial.rarity,
    'Legend Idol Rare': VanguardSpecial.rarity,
    'Legion Rare': VanguardSpecial.rarity,
    'Rummy Labyrinth Rare': VanguardSpecial.rarity,
    'Special Parallel': VanguardSpecial.rarity,
    'Wedding Special Parallel': VanguardSpecial.rarity,
    'Generation Rare': 9,
    'Original Costume Rare': VanguardSpecial.rarity,
    'Super Generation Rare': VanguardSpecial.rarity,
    'Z Rare': VanguardSpecial.rarity,
    'Delete Rare': VanguardSpecial.rarity,
    'Vilest Delete Rare': VanguardSpecial.rarity,
    'Vanguard Rare': 8,
    'Special Vanguard Rare': VanguardSpecial.rarity,
    'Twin Rare': VanguardSpecial.rarity,
    'Twin Vanguard Rare': VanguardSpecial.rarity,
    'Super Special Parallel': VanguardSpecial.rarity,
    'Super Special Rare': VanguardSpecial.rarity,
    'Origin Rare': VanguardSpecial.rarity,
    'Image Ride Rare': VanguardSpecial.rarity,
    'Secret Rare': VanguardSpecial.rarity,
    'Ultra Rare': VanguardSpecial.rarity,
    'Trial Deck': 11,
    'Frame Rare': 12,
    'Double Frame Rare': 13,
};
var DBSRarities = {
    1: { name: 'Token', filterLabel: 'Tok' },
    2: { name: 'Promo', filterLabel: 'Prm' },
    3: { name: 'Starter Rare', filterLabel: 'StR' },
    4: { name: 'Expansion Rare', filterLabel: 'ExR' },
    5: { name: 'Common', filterLabel: 'C', separateFoilBulkPrice: true },
    6: { name: 'Uncommon', filterLabel: 'U', separateFoilBulkPrice: true },
    7: { name: 'Rare', filterLabel: 'R', separateFoilBulkPrice: true },
    8: { name: 'Super Rare', filterLabel: 'SuR', separateFoilBulkPrice: true },
    9: { name: 'Special Rare', filterLabel: 'SpR', separateFoilBulkPrice: true },
    10: { name: 'Feature Rare', filterLabel: 'FeR' },
    11: { name: 'Secret Rare', filterLabel: 'ScR' },
    12: { name: 'God Rare', filterLabel: 'GoR' },
};
var DBSRarityMap = {
    Token: 1,
    Promo: 2,
    'Starter Rare': 3,
    'Expansion Rare': 4,
    Common: 5,
    'Online Code Card': 5,
    Uncommon: 6,
    Rare: 7,
    Leader: 7,
    'Super Rare': 8,
    'Special Rare': 9,
    'Feature Rare': 10,
    'Secret Rare': 11,
    'God Rare': 12,
    'Alternate Art': 12,
};
var FFRarities = {
    1: { name: 'Promo', filterLabel: 'Prm' },
    2: { name: 'Starter', filterLabel: 'Sta' },
    3: { name: 'Common', filterLabel: 'C' },
    4: { name: 'Rare', filterLabel: 'R' },
    5: { name: 'Hero', filterLabel: 'Her' },
    6: { name: 'Legend', filterLabel: 'Leg' },
};
var FFRarityMap = {
    Promo: 1,
    Starter: 2,
    Common: 3,
    Rare: 4,
    Hero: 5,
    Legend: 6,
};
var WSSpecial;
(function (WSSpecial) {
    WSSpecial[WSSpecial["rarity"] = 17] = "rarity";
})(WSSpecial || (WSSpecial = {}));
var wsRarities = (_b = {
        1: { name: 'Trial Deck', filterLabel: 'TrD' },
        2: { name: 'Promo', filterLabel: 'PR' },
        3: { name: 'Common', filterLabel: 'C' },
        4: { name: 'Climax Common', filterLabel: 'CC' },
        5: { name: 'Uncommon', filterLabel: 'U' },
        6: { name: 'Rare', filterLabel: 'R' },
        7: { name: 'Holo', filterLabel: 'Ho' },
        8: { name: 'Climax Rare', filterLabel: 'CR' },
        9: { name: 'Double Rare', filterLabel: 'RR' },
        10: { name: 'Triple Rare', filterLabel: 'RRR' },
        11: { name: 'Extra Rare', filterLabel: 'ExR' },
        12: { name: 'High Rare', filterLabel: 'HiR' },
        13: { name: 'Super Rare', filterLabel: 'SuR' },
        14: { name: 'Parallel Foil', filterLabel: 'PF' },
        15: { name: 'Special Rare', filterLabel: 'SpR' },
        16: { name: 'Super Special Rare', filterLabel: 'SSR' }
    },
    _b[WSSpecial.rarity] = { name: 'Special', filterLabel: 'Spe' },
    _b[18] = { name: 'Feature Rare', filterLabel: 'FeR' },
    _b[19] = { name: 'Secret Rare', filterLabel: 'SeR' },
    _b[20] = { name: 'Overframe Rare', filterLabel: 'OR' },
    _b[21] = { name: 'Power Up Set', filterLabel: 'PUS' },
    _b);
var WSRarityMap = {
    'Trial Deck': 1,
    Promo: 2,
    Common: 3,
    'Climax Common': 4,
    Uncommon: 5,
    Rare: 6,
    Holo: 7,
    'Climax Rare': 8,
    'Double Rare': 9,
    'Triple Rare': 10,
    'Extra Rare': 11,
    'High Rare': 12,
    'Super Rare': 13,
    'Parallel Foil': 14,
    'Special Rare': 15,
    'Super Special Rare': 16,
    'Kaguya Rare': WSSpecial.rarity,
    'Feature Rare': 18,
    'Fujimi Bunko Rare': WSSpecial.rarity,
    'Fun Fale Rare': WSSpecial.rarity,
    'JoJo Rare': WSSpecial.rarity,
    'Special Member': WSSpecial.rarity,
    'Band Rare': WSSpecial.rarity,
    'Starlight Rare': WSSpecial.rarity,
    'Secret Rare': 19,
    'Overframe Rare': 20,
    'Power Up Set': 21,
};
var digimonRarities = {
    1: { name: 'Token', filterLabel: 'Tkn' },
    2: { name: 'Common', filterLabel: 'C' },
    3: { name: 'Uncommon', filterLabel: 'U' },
    4: { name: 'Rare', filterLabel: 'R' },
    5: { name: 'Promo', filterLabel: 'Prm' },
    6: { name: 'Super Rare', filterLabel: 'SuR' },
    7: { name: 'Secret Rare', filterLabel: 'ScR' },
    8: { name: 'Alternative Art', filterLabel: 'Alt' },
};
var digimonRarityMap = {
    Token: 1,
    Common: 2,
    Uncommon: 3,
    Rare: 4,
    Promo: 5,
    'Super Rare': 6,
    'Secret Rare': 7,
    'Alternative Art': 8,
};
var onePieceRarities = {
    1: { name: 'Common', filterLabel: 'C' },
    2: { name: 'Uncommon', filterLabel: 'U' },
    3: { name: 'Rare', filterLabel: 'R' },
    4: { name: 'Leader', filterLabel: 'Ldr' },
    5: { name: 'Super Rare', filterLabel: 'SuR' },
    6: { name: 'Secret Rare', filterLabel: 'ScR' },
    7: { name: 'Alternate Art', filterLabel: 'Alt' },
    8: { name: 'Promo', filterLabel: 'Prm' },
    9: { name: 'DON!!', filterLabel: 'Don' },
    10: { name: 'Manga Rare', filterLabel: 'M' },
    11: { name: 'Special Rare', filterLabel: 'SpR' },
};
var onePieceRarityMap = {
    Common: 1,
    Uncommon: 2,
    Rare: 3,
    Leader: 4,
    'Super Rare': 5,
    'Secret Rare': 6,
    'Alternate Art': 7,
    Promo: 8,
    'DON!!': 9,
    'Manga Rare': 10,
    'Special Rare': 11,
};
// lorcana
var lorcanaRarities = {
    1: { name: 'Common', filterLabel: 'C', separateFoilBulkPrice: true },
    2: { name: 'Uncommon', filterLabel: 'U', separateFoilBulkPrice: true },
    3: { name: 'Rare', filterLabel: 'R', separateFoilBulkPrice: true },
    4: { name: 'Super Rare', filterLabel: 'SuR', separateFoilBulkPrice: true },
    5: { name: 'Legendary', filterLabel: 'L', separateFoilBulkPrice: true },
    6: { name: 'Promo', filterLabel: 'Prm' },
    7: { name: 'Oversized', filterLabel: 'Ovs' },
    8: { name: 'Enchanted', filterLabel: 'En' },
    9: { name: 'Epic', filterLabel: 'Ep' },
    10: { name: 'Iconic', filterLabel: 'I' },
};
var lorcanaRarityMap = {
    Common: 1,
    Uncommon: 2,
    Rare: 3,
    'Super Rare': 4,
    Legendary: 5,
    Promo: 6,
    Oversized: 7,
    Enchanted: 8,
    Epic: 9,
    Iconic: 10,
};
// battle spirits saga
var bssRarities = {
    1: { name: 'Token', filterLabel: 'Tkn' },
    2: { name: 'Common', filterLabel: 'C' },
    3: { name: 'Uncommon', filterLabel: 'U' },
    4: { name: 'Promo', filterLabel: 'Prm' },
    5: { name: 'Rare', filterLabel: 'R' },
    6: { name: 'Lore', filterLabel: 'Lr' },
    7: { name: 'X Rare', filterLabel: 'XR' },
    8: { name: 'Special Rare', filterLabel: 'SpR' },
    9: { name: 'Collaboration Rare', filterLabel: 'CoR' },
    10: { name: 'Saga Rare', filterLabel: 'SaR' },
};
var bssRarityMap = {
    Token: 1,
    Common: 2,
    Uncommon: 3,
    Promo: 4,
    Rare: 5,
    Lore: 6,
    'X Rare': 7,
    'Special Rare': 8,
    'Collaboration Rare': 9,
    'Collaboration X Rare': 9,
    'Saga Rare': 10,
};
// star wars unlimited
var swuRarities = {
    1: { name: 'Starter Deck Exclusive', filterLabel: 'Sde' },
    2: { name: 'Common', filterLabel: 'C' },
    3: { name: 'Uncommon', filterLabel: 'U' },
    4: { name: 'Rare', filterLabel: 'R' },
    5: { name: 'Legendary', filterLabel: 'L' },
};
var swuRarityMap = {
    'Starter Deck Exclusive': 1,
    Common: 2,
    Uncommon: 3,
    Rare: 4,
    Legendary: 5,
};
// Riftbound
var riftboundRarities = {
    1: { name: 'Common', filterLabel: 'C', separateFoilBulkPrice: false },
    2: { name: 'Uncommon', filterLabel: 'U', separateFoilBulkPrice: false },
    3: { name: 'Rare', filterLabel: 'R', separateFoilBulkPrice: true },
    4: { name: 'Epic', filterLabel: 'E', separateFoilBulkPrice: true },
    5: { name: 'Showcase', filterLabel: 'S', separateFoilBulkPrice: true },
};
var riftboundRarityMap = {
    Common: 1,
    Uncommon: 2,
    Rare: 3,
    Epic: 4,
    Showcase: 5,
};
// Cyberpunk
var cyberpunkRarities = {
    1: { name: 'Common', filterLabel: 'C', separateFoilBulkPrice: false },
    2: { name: 'Uncommon', filterLabel: 'U', separateFoilBulkPrice: false },
    3: { name: 'Rare', filterLabel: 'R', separateFoilBulkPrice: true },
    4: { name: 'Epic Rare', filterLabel: 'E', separateFoilBulkPrice: true },
    5: { name: 'Secret Rare', filterLabel: 'S', separateFoilBulkPrice: true },
    6: { name: 'Iconic Rare', filterLabel: 'I', separateFoilBulkPrice: true },
    7: { name: 'Nova Rare', filterLabel: 'N', separateFoilBulkPrice: true },
};
var cyberpunkRarityMap = {
    Common: 1,
    Uncommon: 2,
    Rare: 3,
    'Epic Rare': 4,
    'Secret Rare': 5,
    'Iconic Rare': 6,
    'Nova Rare': 7,
};
// Gundam
// Cardmarket keeps every alternate treatment as its own rarity string ('Rare +', 'Legendary Rare ++',
// ...), so each one gets its own rank instead of collapsing into the base rarity.
var gundamRarities = {
    1: { name: 'Common', filterLabel: 'C' },
    2: { name: 'Common +', filterLabel: 'C+' },
    3: { name: 'Uncommon', filterLabel: 'U' },
    4: { name: 'Uncommon +', filterLabel: 'U+' },
    5: { name: 'Rare', filterLabel: 'R' },
    6: { name: 'Rare +', filterLabel: 'R+' },
    7: { name: 'Legendary Rare', filterLabel: 'LR' },
    8: { name: 'Legendary Rare +', filterLabel: 'LR+' },
    9: { name: 'Legendary Rare ++', filterLabel: 'LR++' },
    10: { name: 'Special Rare', filterLabel: 'SR' },
    11: { name: 'Resource', filterLabel: 'RES' },
    12: { name: 'Resource +', filterLabel: 'RES+' },
    13: { name: 'Resource ++', filterLabel: 'RES++' },
    14: { name: 'Token', filterLabel: 'T' },
};
var gundamRarityMap = {
    Common: 1,
    'Common +': 2,
    Uncommon: 3,
    'Uncommon +': 4,
    Rare: 5,
    'Rare +': 6,
    'Legendary Rare': 7,
    'Legendary Rare +': 8,
    'Legendary Rare ++': 9,
    'Special Rare': 10,
    Resource: 11,
    'Resource +': 12,
    'Resource ++': 13,
    Token: 14,
};
// Sorcery
// Rarity is also the deck-building limit in this game: four copies of an Ordinary down to one of a
// Unique. Avatars and tokens sit outside that scale, so they go last.
var sorceryRarities = {
    1: { name: 'Ordinary', filterLabel: 'O' },
    2: { name: 'Exceptional', filterLabel: 'EX' },
    3: { name: 'Elite', filterLabel: 'EL' },
    4: { name: 'Unique', filterLabel: 'U' },
    5: { name: 'Avatar', filterLabel: 'AV' },
    6: { name: 'Token', filterLabel: 'T' },
};
var sorceryRarityMap = {
    Ordinary: 1,
    Exceptional: 2,
    Elite: 3,
    Unique: 4,
    Avatar: 5,
    Token: 6,
};
exports.gameMetaData = [
    {
        name: types_1.GameName.Generic,
        idGame: 0,
        extraAttr: [],
        cardmarketRarityToNumberMap: {},
        rarities: {},
        pgId: 0,
        addByCardExamples: [],
        addByItemExamples: [],
        competitionPricingEnabled: true,
        playsetCount: 1,
        stockHeaders: [
            'idArticle',
            'idProduct',
            'name',
            'localName',
            'set',
            'expNameObj',
            'price',
            'idLanguage',
            'condition',
            'isFoil',
            'isSigned',
            // 'isPlayset',
            'isAltered',
            'comments',
            'count',
            'onSale',
        ],
        sealedStockHeaders: [
            'idArticle',
            'idProduct',
            'name',
            'localName',
            'set',
            'expNameObj',
            'price',
            'idLanguage',
            'comments',
            'count',
            'onSale',
        ],
        exampleCsv: '',
    },
    {
        name: types_1.GameName.Magic,
        idGame: types_1.IdGame.Magic,
        extraAttr: [types_1.CardExtraAttribute.Foil, types_1.CardExtraAttribute.Signed, types_1.CardExtraAttribute.Playset],
        cardmarketRarityToNumberMap: magicRarityMap,
        rarities: magicRarities,
        pgId: 1,
        addByCardExamples: ['zen 001', 'jace wwk', 'ust plains', '031 jace', 'rabble m15'],
        addByItemExamples: ['fat pack', 'deck moc', 'box sld30'],
        competitionPricingEnabled: true,
        playsetCount: 4,
        stockHeaders: [
            'idArticle',
            'idProduct',
            'name',
            'localName',
            'set',
            'expNameObj',
            'price',
            'idLanguage',
            'condition',
            'isFoil',
            'isSigned',
            // 'isPlayset',
            'isAltered',
            'comments',
            'count',
            'onSale',
        ],
        sealedStockHeaders: [
            'idArticle',
            'idProduct',
            'name',
            'localName',
            'set',
            'expNameObj',
            'price',
            'idLanguage',
            'comments',
            'count',
            'onSale',
        ],
        exampleCsv: "idProduct,quantity,name,set,condition,language,isFoil,isPlayset,isSigned,isFirstEd,price,comment\n     260009,1,Totally Lost,Gatecrash,GD,English,true,true,,,1000,\n     260009,1,Totally Lost,Gatecrash,NM,English,true,true,,,1000,",
    },
    {
        name: types_1.GameName.Yugioh,
        idGame: types_1.IdGame.Yugioh,
        extraAttr: [types_1.CardExtraAttribute.FirstEd, types_1.CardExtraAttribute.Signed],
        cardmarketRarityToNumberMap: yugiohRarityMap,
        rarities: yugiohRarities,
        pgId: 5,
        addByCardExamples: ['lod 001', 'exodia dcr', '034 tyrant', 'horse sod'],
        addByItemExamples: ['pack op21', 'booster sovr', 'sleeves pgb1'],
        playsetCount: 3,
        competitionPricingEnabled: true,
        stockHeaders: [
            'idArticle',
            'idProduct',
            'name',
            'localName',
            'set',
            'expNameObj',
            'price',
            'idLanguage',
            'condition',
            'isSigned',
            'isFirstEd',
            'isAltered',
            'comments',
            'count',
            'onSale',
        ],
        sealedStockHeaders: [
            'idArticle',
            'idProduct',
            'name',
            'localName',
            'set',
            'expNameObj',
            'price',
            'idLanguage',
            'comments',
            'count',
            'onSale',
        ],
        exampleCsv: "cardmarketId,quantity,name,set,cn,condition,language,isFirstEd,isSigned,price,comment\n     534168,2,Blue-Eyes Alternative White Dragon (V.2 - Ultra Rare),Legendary Duelists: Season 2,8,EX,English,,,1000,\n     292084,1,Slifer the Sky Dragon,2016 Mega-Tins,1,NM,English,true,,1000,",
    },
    {
        name: types_1.GameName.Pokemon,
        idGame: types_1.IdGame.Pokemon,
        extraAttr: [
            types_1.CardExtraAttribute.FirstEd,
            types_1.CardExtraAttribute.Signed,
            types_1.CardExtraAttribute.ReverseHolo,
            types_1.CardExtraAttribute.Playset,
        ],
        cardmarketRarityToNumberMap: pokemonRarityMap,
        rarities: pokemonRarities,
        addByCardExamples: ['exs pikachu', 'sm-p 044', 'squirtle pop4', '023 pikachu', 'dewgong gc'],
        addByItemExamples: ['pack pal', 'booster sv2d', 'deck pr'],
        pgId: 51,
        competitionPricingEnabled: true,
        playsetCount: 4,
        stockHeaders: [
            'idArticle',
            'idProduct',
            'name',
            'localName',
            'set',
            'expNameObj',
            'price',
            'idLanguage',
            'condition',
            'isReverseHolo',
            'isSigned',
            'isFirstEd',
            // 'isPlayset',
            'isAltered',
            'comments',
            'count',
            'onSale',
        ],
        sealedStockHeaders: [
            'idArticle',
            'idProduct',
            'name',
            'localName',
            'set',
            'expNameObj',
            'price',
            'idLanguage',
            'comments',
            'count',
            'onSale',
        ],
        exampleCsv: "cardmarketId,quantity,name,set,cn,condition,language,isPlayset,isFirstEd,isReverseHolo,isSigned,price,comment\n     388102,2,Pikachu ,Unified Minds,56,NM,English,,true,,,1000,\n     273758,1,Squirtle ,Base Set,63,NM,French,true,,,,1000,",
    },
    {
        name: types_1.GameName.FAB,
        idGame: types_1.IdGame.FAB,
        extraAttr: [types_1.CardExtraAttribute.Signed],
        cardmarketRarityToNumberMap: fabRarityMap,
        rarities: fabRarities,
        competitionPricingEnabled: true,
        addByCardExamples: ['arc-f achilles', 'ira 001', 'WTR032-C'],
        addByItemExamples: ['deck 1ht', 'booster dyn', 'sleeves mon'],
        cardmarketName: 'FleshAndBlood',
        pgId: 100,
        playsetCount: 3,
        stockHeaders: [
            'idArticle',
            'idProduct',
            'name',
            'localName',
            'set',
            'expNameObj',
            'price',
            'idLanguage',
            'condition',
            'isSigned',
            'isAltered',
            'comments',
            'count',
            'onSale',
        ],
        sealedStockHeaders: [
            'idArticle',
            'idProduct',
            'name',
            'localName',
            'set',
            'expNameObj',
            'price',
            'idLanguage',
            'comments',
            'count',
            'onSale',
        ],
        exampleCsv: "cardmarketId,quantity,name,set,cn,condition,language,isSigned,price,comment\n    601228,2,Absorb in Aether (Blue) (Normal),Arcane Rising - First,ARC125-R,NM,English,,333,qwe\n    601244,3,Aether Flare (Yellow) (Normal),Arcane Rising - First,ARC133-C,NM,English,,333,\n    ,1,Scabskin Leathers (Regular),1HP,007,NM,English,,200,",
    },
    {
        name: types_1.GameName.Vanguard,
        idGame: types_1.IdGame.Vanguard,
        extraAttr: [types_1.CardExtraAttribute.Signed, types_1.CardExtraAttribute.Playset],
        cardmarketRarityToNumberMap: vanguardRarityMap,
        rarities: vanguardRarities,
        competitionPricingEnabled: true,
        addByCardExamples: ['EB02 diva', 'bt14 005', 'dragon G-BT12', '005 cardinal', 'iryna'],
        addByItemExamples: ['pack pr', 'booster bt09', 'deck d-ss03'],
        pgId: 100,
        playsetCount: 4,
        stockHeaders: [
            'idArticle',
            'idProduct',
            'name',
            'localName',
            'set',
            'expNameObj',
            'price',
            'idLanguage',
            'condition',
            'isSigned',
            // 'isPlayset',
            'isAltered',
            'comments',
            'count',
            'onSale',
        ],
        sealedStockHeaders: [
            'idArticle',
            'idProduct',
            'name',
            'localName',
            'set',
            'expNameObj',
            'price',
            'idLanguage',
            'comments',
            'count',
            'onSale',
        ],
        exampleCsv: "cardmarketId,quantity,name,set,cn,condition,language,isPlayset,isSigned,price,comment\n    359911,1,Boomerang Thrower [V Format],Unite! Team Q4,40,NM,English,,,1000,cheap shipping\n    308250,2,Rear Impetus Celestial, Armaiti [G Format],Glorious Bravery of Radiant Sword,49,EX,English,,,1000,",
    },
    {
        name: types_1.GameName.DBS,
        idGame: types_1.IdGame.DBS,
        cardmarketName: 'DragonBallSuper',
        extraAttr: [types_1.CardExtraAttribute.Signed, types_1.CardExtraAttribute.Foil],
        cardmarketRarityToNumberMap: DBSRarityMap,
        rarities: DBSRarities,
        competitionPricingEnabled: true,
        addByCardExamples: ['bt2 goku', 'goku bt10', 'bt7 005', '031 broly', 'blaster eb1'],
        addByItemExamples: ['pack bt20', 'box be21', 'deck ex16'],
        pgId: 100,
        playsetCount: 4,
        stockHeaders: [
            'idArticle',
            'idProduct',
            'name',
            'localName',
            'set',
            'expNameObj',
            'price',
            'idLanguage',
            'condition',
            'isFoil',
            'isSigned',
            'isAltered',
            'comments',
            'count',
            'onSale',
        ],
        sealedStockHeaders: [
            'idArticle',
            'idProduct',
            'name',
            'localName',
            'set',
            'expNameObj',
            'price',
            'idLanguage',
            'comments',
            'count',
            'onSale',
        ],
        exampleCsv: "cardmarketId,quantity,name,set,cn,condition,language,isFoil,isSigned,price,comment\n    384117,1,Goku Black & Zamasu // Fused Zamasu, Supreme Strike,Series 7 Pre-Release Promos,26,NM,English,true,,1000,\n    434079,2,Light Bullet,Universal Onslaught,68,NM,German,,,1000,",
    },
    {
        name: types_1.GameName.FF,
        idGame: types_1.IdGame.FF,
        cardmarketName: 'FinalFantasy',
        extraAttr: [types_1.CardExtraAttribute.Signed, types_1.CardExtraAttribute.Foil],
        cardmarketRarityToNumberMap: FFRarityMap,
        rarities: FFRarities,
        competitionPricingEnabled: true,
        addByCardExamples: ['7 seph', '8 004', 'seph 3', '023 bryn', 'mask 8'],
        addByItemExamples: ['box op15', 'deck pr', 'sleeves pr'],
        pgId: 100,
        playsetCount: 3,
        stockHeaders: [
            'idArticle',
            'idProduct',
            'name',
            'localName',
            'set',
            'expNameObj',
            'price',
            'idLanguage',
            'condition',
            'isFoil',
            'isSigned',
            'isAltered',
            'comments',
            'count',
            'onSale',
        ],
        sealedStockHeaders: [
            'idArticle',
            'idProduct',
            'name',
            'localName',
            'set',
            'expNameObj',
            'price',
            'idLanguage',
            'comments',
            'count',
            'onSale',
        ],
        exampleCsv: "cardmarketId,quantity,name,set,cn,condition,language,isFoil,isSigned,price,comment\n    365034,1,Jecht (7-010),Opus VII,10,EX,German,,,1000,\n    365896,2,Lann (7-018),Opus VII,18,NM,English,,,1000,cheap shipping",
    },
    {
        name: types_1.GameName.WS,
        idGame: types_1.IdGame.WS,
        cardmarketName: 'WeissSchwarz',
        extraAttr: [types_1.CardExtraAttribute.Signed],
        cardmarketRarityToNumberMap: WSRarityMap,
        rarities: wsRarities,
        competitionPricingEnabled: true,
        addByCardExamples: ['t07 date', 'DAL/w79 shido'],
        addByItemExamples: ['box kmd', 'sleeves kgl', 'booster sao'],
        pgId: 100,
        playsetCount: 4,
        stockHeaders: [
            'idArticle',
            'idProduct',
            'name',
            'localName',
            'set',
            'expNameObj',
            'price',
            'idLanguage',
            'condition',
            'isSigned',
            'isAltered',
            'comments',
            'count',
            'onSale',
        ],
        sealedStockHeaders: [
            'idArticle',
            'idProduct',
            'name',
            'localName',
            'set',
            'expNameObj',
            'price',
            'idLanguage',
            'comments',
            'count',
            'onSale',
        ],
        exampleCsv: "cardmarketId,quantity,name,set,cn,condition,language,isSigned,price,comment\n    555788,1,Date Day, Tohka,Date A Live,T07,NM,English,true,1000,\n    555832,1,My Little Shido (TD),Date A Live,T18,NM,English,,1000,\n    555838,1,Searching for Yoshinon,Date A Live,T20,EX,English,,1000,",
    },
    {
        name: types_1.GameName.Digimon,
        idGame: types_1.IdGame.Digimon,
        extraAttr: [types_1.CardExtraAttribute.Signed],
        cardmarketRarityToNumberMap: digimonRarityMap,
        rarities: digimonRarities,
        competitionPricingEnabled: true,
        addByCardExamples: ['otpe garg', 'P-034'],
        addByItemExamples: ['pack cp22', 'sleeves dmpr', 'box bt-12'],
        pgId: 100,
        playsetCount: 4,
        stockHeaders: [
            'idArticle',
            'idProduct',
            'name',
            'localName',
            'set',
            'expNameObj',
            'price',
            'idLanguage',
            'condition',
            'isSigned',
            'isAltered',
            'comments',
            'count',
            'onSale',
        ],
        sealedStockHeaders: [
            'idArticle',
            'idProduct',
            'name',
            'localName',
            'set',
            'expNameObj',
            'price',
            'idLanguage',
            'comments',
            'count',
            'onSale',
        ],
        exampleCsv: "cardmarketId,quantity,name,set,setCode,cn,condition,language,isSigned,price,comment\n    621045,1,Red Memory Boost! (P-035) (V.1),Promos,P,P-035,GD,English,,1000,\n    650130,1,Transcendent Sword (BT5-095),Promos: Battle Of Omni,BT-05P,BT5-095,PO,English,,1000,\n    621085,1,Victory Sword (ST8-11),Starter Deck: UlforceVeedramon,ST-8,ST8-11,NM,English,,1000,",
    },
    {
        name: types_1.GameName.OnePiece,
        idGame: types_1.IdGame.OnePiece,
        extraAttr: [types_1.CardExtraAttribute.Signed],
        cardmarketRarityToNumberMap: onePieceRarityMap,
        rarities: onePieceRarities,
        competitionPricingEnabled: true,
        addByCardExamples: ['caribou', 'OP01-007'],
        addByItemExamples: ['sleeves stp', 'box op-02', 'deck oppr'],
        pgId: 100,
        playsetCount: 4,
        stockHeaders: [
            'idArticle',
            'idProduct',
            'name',
            'localName',
            'set',
            'expNameObj',
            'price',
            'idLanguage',
            'condition',
            'isSigned',
            'isAltered',
            'comments',
            'count',
            'onSale',
        ],
        sealedStockHeaders: [
            'idArticle',
            'idProduct',
            'name',
            'localName',
            'set',
            'expNameObj',
            'price',
            'idLanguage',
            'comments',
            'count',
            'onSale',
        ],
        exampleCsv: "cardmarketId,quantity,name,set,setCode,cn,condition,language,isSigned,price,comment\n    690810,1,Sanji (OP01-013) (V.2),Romance Dawn,OP-01,OP01-013,GD,English,,1000,\n    691235,1,Crocodile (P-004),Promos,P,P-004,PO,English,,1000,\n    621085,1,Ulti (ST04-002) (V.1),Starter Deck: Animal Kingdom Pirates,ST-04,ST04-002,NM,English,,1000,",
    },
    {
        name: types_1.GameName.Lorcana,
        idGame: types_1.IdGame.Lorcana,
        extraAttr: [types_1.CardExtraAttribute.Foil],
        cardmarketRarityToNumberMap: lorcanaRarityMap,
        rarities: lorcanaRarities,
        pgId: 100,
        addByCardExamples: ['aladdin', '1TFC-001'],
        addByItemExamples: ['glitter', 'deck box'],
        competitionPricingEnabled: true,
        playsetCount: 4,
        stockHeaders: [
            'idArticle',
            'idProduct',
            'name',
            'localName',
            'set',
            'expNameObj',
            'price',
            'idLanguage',
            'condition',
            'isSigned',
            'isAltered',
            'isFoil',
            'comments',
            'count',
            'onSale',
        ],
        sealedStockHeaders: [
            'idArticle',
            'idProduct',
            'name',
            'localName',
            'set',
            'expNameObj',
            'price',
            'idLanguage',
            'comments',
            'count',
            'onSale',
        ],
        exampleCsv: "idProduct,quantity,name,set,condition,language,isFoil,isSigned,price,comment\n    729284,1,Abu - Mischievous Monkey,The First Chapter,NM,English,true,false,1000,\n    729359,1,Aladdin - Cornered Swordsman,The First Chapter,NM,English,false,false,1000",
    },
    {
        name: types_1.GameName.BSS,
        idGame: types_1.IdGame.BSS,
        extraAttr: [types_1.CardExtraAttribute.Foil, types_1.CardExtraAttribute.Signed],
        cardmarketRarityToNumberMap: bssRarityMap,
        rarities: bssRarities,
        pgId: 100,
        addByCardExamples: ['emerantman', 'BSS01-002'],
        addByItemExamples: ['judgde pack', 'ST02'],
        cardmarketName: 'BattleSpiritsSaga',
        competitionPricingEnabled: true,
        playsetCount: 4,
        stockHeaders: [
            'idArticle',
            'idProduct',
            'name',
            'localName',
            'set',
            'expNameObj',
            'price',
            'idLanguage',
            'condition',
            'isSigned',
            'isAltered',
            'isFoil',
            'comments',
            'count',
            'onSale',
        ],
        sealedStockHeaders: [
            'idArticle',
            'idProduct',
            'name',
            'localName',
            'set',
            'expNameObj',
            'price',
            'idLanguage',
            'comments',
            'count',
            'onSale',
        ],
        exampleCsv: "idProduct,quantity,name,set,condition,language,isFoil,isSigned,price,comment\n    728585,1,Flamefish,Dawn of History,NM,English,false,false,1000,\n    728541,1,White Hole Dragon,Dawn of History,NM,English,false,false,1000",
    },
    {
        name: types_1.GameName.SWU,
        idGame: types_1.IdGame.SWU,
        extraAttr: [types_1.CardExtraAttribute.Foil, types_1.CardExtraAttribute.Signed],
        cardmarketRarityToNumberMap: swuRarityMap,
        rarities: swuRarities,
        pgId: 100,
        addByCardExamples: ['luke skywalker', 'SOR-005'],
        addByItemExamples: ['darth vader playmat', 'SOR'],
        cardmarketName: 'StarWarsUnlimited',
        competitionPricingEnabled: true,
        playsetCount: 4,
        stockHeaders: [
            'idArticle',
            'idProduct',
            'name',
            'localName',
            'set',
            'expNameObj',
            'price',
            'idLanguage',
            'condition',
            'isSigned',
            'isFoil',
            'comments',
            'count',
            'onSale',
        ],
        sealedStockHeaders: [
            'idArticle',
            'idProduct',
            'name',
            'localName',
            'set',
            'expNameObj',
            'price',
            'idLanguage',
            'comments',
            'count',
            'onSale',
        ],
        exampleCsv: "idProduct,quantity,name,set,condition,language,isFoil,isSigned,price,comment\n    755172,1,I Am Your Father,Spark of Rebellion,NM,English,false,false,1000,\n    755128,1,Death Trooper,Spark of Rebellion,NM,English,false,false,1000,",
    },
    {
        name: types_1.GameName.Riftbound,
        idGame: types_1.IdGame.Riftbound,
        extraAttr: [types_1.CardExtraAttribute.Foil],
        cardmarketRarityToNumberMap: riftboundRarityMap,
        rarities: riftboundRarities,
        pgId: 100,
        addByCardExamples: [],
        addByItemExamples: [],
        cardmarketName: 'Riftbound',
        competitionPricingEnabled: true,
        playsetCount: 4,
        stockHeaders: [
            'idArticle',
            'idProduct',
            'name',
            'localName',
            'set',
            'expNameObj',
            'price',
            'idLanguage',
            'condition',
            'isFoil',
            'comments',
            'count',
            'onSale',
        ],
        sealedStockHeaders: [
            'idArticle',
            'idProduct',
            'name',
            'localName',
            'set',
            'expNameObj',
            'price',
            'idLanguage',
            'comments',
            'count',
            'onSale',
        ],
        exampleCsv: "idProduct,quantity,name,set,condition,language,isFoil,price,comment\n    847468,1,Bullet Time,Origins,NM,English,false,1000,\n    847425,1,Baited Hook,Origins,NM,English,false,1000,",
    },
    {
        name: types_1.GameName.Cyberpunk,
        idGame: types_1.IdGame.Cyberpunk,
        extraAttr: [types_1.CardExtraAttribute.Foil],
        cardmarketRarityToNumberMap: cyberpunkRarityMap,
        rarities: cyberpunkRarities,
        pgId: 100,
        addByCardExamples: [],
        addByItemExamples: [],
        cardmarketName: 'Cyberpunk',
        competitionPricingEnabled: true,
        playsetCount: 4,
        stockHeaders: [
            'idArticle',
            'idProduct',
            'name',
            'localName',
            'set',
            'expNameObj',
            'price',
            'idLanguage',
            'condition',
            'isFoil',
            'comments',
            'count',
            'onSale',
        ],
        sealedStockHeaders: [
            'idArticle',
            'idProduct',
            'name',
            'localName',
            'set',
            'expNameObj',
            'price',
            'idLanguage',
            'comments',
            'count',
            'onSale',
        ],
        exampleCsv: "idProduct,quantity,name,set,condition,language,isFoil,price,comment\n    847546,1,Decisive Strike,Proving Grounds,NM,English,false,1000,\n    847273,1,Unchecked Power,Origins,NM,English,false,1000,",
    },
    {
        name: types_1.GameName.Gundam,
        idGame: types_1.IdGame.Gundam,
        extraAttr: [types_1.CardExtraAttribute.Foil, types_1.CardExtraAttribute.Signed],
        cardmarketRarityToNumberMap: gundamRarityMap,
        rarities: gundamRarities,
        pgId: 100,
        addByCardExamples: ['guncannon', 'GD01-004'],
        addByItemExamples: ['box gd01', 'deck st01'],
        cardmarketName: 'Gundam',
        competitionPricingEnabled: true,
        playsetCount: 4,
        stockHeaders: [
            'idArticle',
            'idProduct',
            'name',
            'localName',
            'set',
            'expNameObj',
            'price',
            'idLanguage',
            'condition',
            'isSigned',
            'isAltered',
            'comments',
            'count',
            'onSale',
        ],
        sealedStockHeaders: [
            'idArticle',
            'idProduct',
            'name',
            'localName',
            'set',
            'expNameObj',
            'price',
            'idLanguage',
            'comments',
            'count',
            'onSale',
        ],
        exampleCsv: "cardmarketId,quantity,name,set,setCode,cn,condition,language,isSigned,price,comment\n    905538,1,Guncannon (GD01-004),Newtype Rising,GD01,GD01-004,NM,English,,1000,\n    905826,1,Gundam (ST01-001) (V.1 - Legendary Rare),Starter Deck: Heroic Beginnings,ST01,ST01-001,NM,English,,1000,",
    },
    {
        name: types_1.GameName.Sorcery,
        idGame: types_1.IdGame.Sorcery,
        extraAttr: [types_1.CardExtraAttribute.Foil, types_1.CardExtraAttribute.Signed],
        cardmarketRarityToNumberMap: sorceryRarityMap,
        rarities: sorceryRarities,
        pgId: 100,
        addByCardExamples: ['cloud city', 'roaming monster'],
        addByItemExamples: ['box alpha', 'box beta'],
        cardmarketName: 'Sorcery: Contested Realm',
        competitionPricingEnabled: true,
        playsetCount: 4,
        stockHeaders: [
            'idArticle',
            'idProduct',
            'name',
            'localName',
            'set',
            'expNameObj',
            'price',
            'idLanguage',
            'condition',
            'isFoil',
            'isSigned',
            'isAltered',
            'comments',
            'count',
            'onSale',
        ],
        sealedStockHeaders: [
            'idArticle',
            'idProduct',
            'name',
            'localName',
            'set',
            'expNameObj',
            'price',
            'idLanguage',
            'comments',
            'count',
            'onSale',
        ],
        exampleCsv: "idProduct,quantity,name,set,condition,language,isFoil,price,comment\n    911366,1,Roaming Monster,Alpha,NM,English,false,1000,\n    910822,1,Cloud City,Alpha,NM,English,false,1000,",
    },
];
var getGameMetaData = function (idGame) {
    var game = exports.gameMetaData.find(function (g) { return g.idGame === idGame; });
    if (!game)
        throw new Error("Game with id ".concat(idGame, " not found"));
    return game;
};
exports.getGameMetaData = getGameMetaData;
//# sourceMappingURL=gameMetaData.js.map